import React from "react";

export const Cloud12 = ({ x = 0, y = 0 }) => (
  <g style={{ transform: `translate(${x}px, ${y}px)` }}>
    <rect width={44} height={28} rx={1} fill="#F1F2F6" />

    <g
      stroke="#8E97A9"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1={4.9} y1={7} x2={11.9} y2={7} strokeWidth={4} />
      <line x1={18.9} y1={7} x2={25.9} y2={7} strokeWidth={3} />
      <line x1={33.9} y1={7} x2={40.9} y2={7} />
      <line x1={9.9} y1={14} x2={22.9} y2={14} />
      <line x1={19.9} y1={21} x2={30.9} y2={21} />
      <line x1={36.9} y1={21} x2={39.9} y2={21} />
      <line x1={27.9} y1={14} x2={34.9} y2={14} strokeWidth={4} />
      <line x1={2.9} y1={21} x2={13.9} y2={21} strokeWidth={4} />
    </g>
  </g>
);
